<template>
    <tr class="hover:bg-sky-50 transition-colors duration-150">
        <slot />
    </tr>
</template>

<script setup>
defineOptions({
    name: 'ZenGridBodyRow',
})
</script>
